import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeVarys';
const args = {};

export class ModeVarys extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
